import React, { useContext, useEffect, useState } from 'react';
import {
  Grid,
  Typography,
} from '@material-ui/core';

import {
  useParams,
} from 'react-router-dom';

import moment from 'moment';

import PropTypes from 'prop-types';

import CarersSection from '../../fields/carersSection';
import EventsSection from '../../fields/eventsSection';
import FormsSection from '../../fields/formsSection';
import TeamSection from '../../fields/teamSection';
import SpinnerLoading from '../../feedback/spinnerLoading';

import { getEnrolment, getEnrolmentUserSchedules, getProgramEventTypes, getProgramInfo } from '../../../utils/comms';

import { extraDays } from '../../../utils/constants';

import translations from  '../../../languages/i18n';

import { SessionContext } from '../../../utils/context';

export default function EnrolmentDetails({ detailsData, handleFeedback }) {
  const sessionContext = useContext(SessionContext);

  const [dataFromServer, setDataFromServer] = useState(false);
  const [enrolmentData, setEnrolmentData] = useState({});
  const [infoReady, setInfoReady] = useState(false);
  const [obtainUserSchedules, setObtainUserSchedules] = useState(false);
  const [programAdministratorIds, setProgramAdministratorIds] = useState([]);
  const [programEventTypes, setProgramEventTypes] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [userSchedulesData, setUserSchedulesData] = useState([]);
  const [fillInFormsPlatforms, setFillInFormsPlatforms] = useState([]);
  const [userType, setUserType] = useState('');

  const { idEnrolment } = useParams();

  const getFillInFormsPlatforms = (programData) => {
    // ATENCIÓ: els noms de les propietats de l'objecte platform han d'estar amb majúscules per que coincideixin amb els rols dels usuaris a la BDD
    const platforms = {
      Carer: programData.carerFormsPlatform,
      Clinician: programData.clinicianFormsPlatform,
      Patient: programData.patientFormsPlatform,
    };
    setFillInFormsPlatforms(platforms);
  };

  const getTypeOfUser = async (idUser, enrolmentTeam, programId) => {
    const response = await getProgramInfo(programId, sessionContext.userToken);
    if (response.status === 200) { // Tenim info del programa
      // Agafam les plataformes des d'on cada tipus d'usuari ha de contestar el formulari
      getFillInFormsPlatforms(response.data.program);
      // Agafam els ids dels administradors del programa
      const progAdministratorIds = response.data.program.accessibleBy.clinicians.filter((clinician) => clinician.admin === true);
      setProgramAdministratorIds(progAdministratorIds);
      if (sessionContext.role === 'Admin') return 'AppAdmin';
      // Extreim el clínic de l'equip clínic
      const memberObj = enrolmentTeam.find((member) => member.clinician._id === idUser);
      // Si memberObj és undefined vol dir que l'usuari clínic no està dins l'equip de l'enrolment, per tant només pot haver arribat aquí essent administrador del programa
      if (!memberObj) return 'Administrator';
      // Miram si és l'usuari clinic supervisor de l'equip
      // Feim aquesta comprovació primer per donar prioritat al fet que sigui supervisor sobre que sigui administrador del programa
      if (memberObj.admin) return 'Supervisor';
      // Miram si l'usuari està dins el llistat d'aministradors del programa
      return progAdministratorIds.find((administratorId) => administratorId.clinician._id === idUser) ? 'Administrator' : 'Basic';
    }
    // En cas de que s'hagi produit un error en la comunicació i no poguem saber quin tipus d'usuari és, tornam el Basic
    return 'Basic';
  };

  // Funció antiga per calcular si el formulari ha "caducat" tenint en compte l'hora exacte del formulari
  /* const isCurrent_exact = (from, daysToFillIn) => {
    const now = Date.now(); // En milisegons des de 01/01/1970 en HORA LOCAL (GMT + alguna cosa)
    // Date.parse(from) dona els milisegons que han passat des de 01/01/1970 en HORA LOCAL (GMT + alguna cosa)
    // Al servidor les dates es guarden en hora Zulu (que equival a un desfase de +00:00), en fer el Date del que rebem del servidor
    // ens torna la data en HORA LOCAL (GMT + alguna cosa) o al manco això he deduit de les proves

    // Si la data actual és superior a la data inicial per omplir el formulari més els dies que hi ha per contestar-lo, el formulari ja no es pot emplenar i no el mostram al llistat
    if (now > (Date.parse(from) + daysToFillIn * 24 * 60 * 60 * 1000)) return false;
    return true;
  }; */

  // Miram si el formulari ha "caducat"
  const isCurrent = (from, daysToFillIn) => {
    const today = moment().format('YYYY-MM-DD');
    const lastDay = moment(from).add(daysToFillIn + extraDays, 'days').format('YYYY-MM-DD'); // Afegim extraDays (normalment 1) al daysToFillIn perquè començam a comptar els dies a partir del dia següent al from
    if (moment(today).isSameOrAfter(lastDay)) return false; // ATENCIÓ: la condició és isSameOrAfter i no isAfter donat que lastDay ja inclou el dia "extra" i, per tant, el formulari ja està caducat
    return true;
  };

  useEffect(() => {
    const getEnrolmentInfoFromServer = async () => {
      setObtainUserSchedules(false);
      setShowLoading(true);
      let typeOfUser = '';
      const responseEnrolmentData = await getEnrolment(idEnrolment, sessionContext.userToken);
      if (responseEnrolmentData.status === 200) { // Tenim enrolment
        // Consultam quin tipus d'usuari és
        // NOTA: dins getTypeOfUser també agafam les plataformes des d'on cada tipus d'usuari ha de contestar el formulari 
        typeOfUser = await getTypeOfUser(sessionContext.userId, responseEnrolmentData.data.enrolment.supervisedBy, responseEnrolmentData.data.enrolment.program._id);
        setUserType(typeOfUser);
        setEnrolmentData(responseEnrolmentData.data.enrolment);
        const responseFromServer = await Promise.all([
          getProgramEventTypes(responseEnrolmentData.data.enrolment.program._id, sessionContext.userToken),
          getEnrolmentUserSchedules(idEnrolment, sessionContext.userToken), // Demanam tots els formularis d'aquesta subscripció
        ]);
        // Comprovam si dins les respostes n'hi ha alguna de timeOut o erronia
        const allOk = responseFromServer.map((answer) => {
          if (answer.status && answer.status === 200) return 'ok';
          if (answer === 'timeOut') return 'timeOut';
          return 'error';
        });
        const idTO = allOk.indexOf('timeOut');
        const idE = allOk.indexOf('error');
        if (idTO > -1 || idE > -1) { // Al manco hi ha 1 timeOut o 1 error
          // Miram si algun dels errors rebuts és un timeOut
          if (idTO > -1) { // Hi ha hagut un timeOut
            handleFeedback('error', 'TimeOut');
          } else { // Hi ha hagut un error
            handleFeedback('error', 'Generic');
          }
        } else { // No hi ha cap error
          setProgramEventTypes(responseFromServer[0].data.eventTypes);
          // No mostram els userSchedules "caducats", els que ja se'ls ha passat el temps per emplenar-los
          const currentUserSchedules = responseFromServer[1].data.userSchedules.filter((userSchedule) => isCurrent(userSchedule.from, userSchedule.daysToFillIn));
          // No mostram els userSchedules de pacients que estiguin completats (maldament no estiguin caducats)
          const notCompletedUserSchedules = currentUserSchedules.filter((userSchedule) => !(userSchedule.role === 'Patient' && userSchedule.completed === true));
          // Ordenam l'array amb tots els userSchedules per data
          const orderedUserSchedules = notCompletedUserSchedules.sort((uS1, uS2) => {
            // Ordre descendent, les dates més llunyanes al dia d'avui primer
            // return new Date(uS2.from) - new Date(uS1.from);
            // Ordre ascendent, les dates més properes al dia d'avui primer
            return new Date(uS1.from) - new Date(uS2.from);
          });
          setUserSchedulesData(orderedUserSchedules);
          setDataFromServer(true);
        }
      } else if (responseEnrolmentData === 'timeOut') { // El servidor està caigut o l'usuari no té connexió
        handleFeedback('error', 'TimeOut');
      } else { // Error amb les dades o al servidor
        handleFeedback('error', 'Generic');
      }
      
      setShowLoading(false);
      setInfoReady(true);
    };
    // sessionContext.userData = null; // Buidam les dades per només guardar les darreres obtingudes del servidor
    getEnrolmentInfoFromServer();
  }, [obtainUserSchedules]);

  /* const obtainEnrolment = async () => {
    setShowLoading(true);
    const response = await getEnrolment(idEnrolment, sessionContext.userToken);
    setShowLoading(false);
    if (response.status === 200) { // Tenim enrolment actualitzat
      // Consultam quin tipus d'usuari és
      const typeOfUser = await getTypeOfUser(sessionContext.userId, response.data.enrolment.supervisedBy, response.data.enrolment.program._id);
      setUserType(typeOfUser);
      setEnrolmentData(response.data.enrolment);
    } else if (response === 400) { // Error amb les dades
      console.log('Error 400');
    } else { // Login KO. Altres errors
      console.log(response);
    }
  }; */

  return (
    <React.Fragment>
      <SpinnerLoading show={showLoading} />
      {infoReady && (
        <div /* className={classes.body} */>
          <Grid container direction='column' spacing={2}>
            {/* +++++++++++++++++++++++++++++++++++ Nom del programa +++++++++++++++++++++++++++++++++++ */}
            <Grid item xs={12} /*className={sectionTitleStyle.root}*/>
              {dataFromServer && <Typography variant='h5' component='div'>{translations[enrolmentData.program.sharedId] || enrolmentData.program.name}</Typography>}
            </Grid>
            {/* +++++++++++++++++++++++++++++++++++ EVENTS +++++++++++++++++++++++++++++++++++ */}
            <Grid item xs={12}>
              {/* Si el programa no té EventTypes, no deixam crear events */}
              {(programEventTypes && dataFromServer && (
                <EventsSection userType={userType} enrolmentData={enrolmentData} eventTypes={programEventTypes} handleReloadUserSchedules={() => setObtainUserSchedules(true)} patientData={detailsData} />
              )) || (
                <Typography variant='body1' component='div'>{translations['_programWithoutEventTypes']}</Typography>
              )}
            </Grid>
            {/* +++++++++++++++++++++++++++++++++++ FORMS +++++++++++++++++++++++++++++++++++ */}
            <Grid item xs={12}>
              <Grid container justify='flex-start' spacing={4}>
                <Grid item xs={12}>
                  {dataFromServer && <FormsSection userSchedulesData={userSchedulesData} patientId={enrolmentData.patient._id} programId={enrolmentData.program._id} userType={userType} fillInFormsPlatforms={fillInFormsPlatforms} />}
                </Grid>
              </Grid>
            </Grid>
            {/* +++++++++++++++++++++++++++++++++++ EQUIPS +++++++++++++++++++++++++++++++++++ */}
            <Grid item xs={12}>
              <Grid container justify='flex-start' spacing={4}>
                <Grid item xs={6}>
                  {dataFromServer && <TeamSection userType={userType} enrolmentData={enrolmentData} programAdministratorIds={programAdministratorIds} handleReloadEnrolments={() => setObtainUserSchedules(true)} title={translations['_clinicalTeam']}/>}
                </Grid>
                <Grid item xs={6}>
                  {dataFromServer && <CarersSection userType={userType} enrolmentData={enrolmentData} title={translations['_carers']} />}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}
    </React.Fragment>
  );
}

// Indica i controla els props que se han de passar al component
EnrolmentDetails.propTypes = {
  detailsData: PropTypes.object.isRequired,
  handleFeedback: PropTypes.func.isRequired,
};
